import { useState, useEffect } from 'react'

export const useIsMobile = (isClient = typeof window !== 'undefined') => {
  const [isMobile, setIsMobile] = useState(() => {
    if (!isClient) {
      return false
    }
    return window?.innerWidth < 1024
  })

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024)
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}
